import { render } from "./ProfilePay.vue?vue&type=template&id=ca6d15f8&scoped=true"
import script from "./ProfilePay.vue?vue&type=script&lang=js"
export * from "./ProfilePay.vue?vue&type=script&lang=js"

import "./ProfilePay.vue?vue&type=style&index=0&id=ca6d15f8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca6d15f8"]])

export default __exports__